export const SURVEY_AUDIENCE_PARTICIPANT = {
    label: 'Participants',
    value: 'participants',
    _id: '66dbf1e9c79cf1f47992c3ef',
    description: 'People who receive services that are known to the system',
};

//changed
export const SURVEY_AUDIENCE_SYSTEM_USER = {
    label: 'Users',
    value: 'users',
    _id: '66dbf20652ff7ecb11eb4491',
    description: 'People who have an account in the system',
};

export const SURVEY_AUDIENCE_VISITOR = {
    label: 'Visitors',
    value: 'visitors',
    _id: '66dbf2192b8747f3c89f0e8d',
    description: 'People who receive services that are not identified in the system',
};

export const SURVEY_AUDIENCE_TYPES = [
    SURVEY_AUDIENCE_PARTICIPANT,
    SURVEY_AUDIENCE_SYSTEM_USER,
    SURVEY_AUDIENCE_VISITOR,
];
